import { gql } from '@apollo/client';
import { REPORTING_REQUIREMENT_DETAIL } from '../fragments/reportingRequirement';

export const SAVE_REPORTING_REQUIREMENT = gql`
  mutation saveReportingRequirement($input: SaveReportingRequirementInput!) {
    result: saveReportingRequirement(input: $input) {
      requirement {
        ...reportingRequirementDetail
      }
      periodsCreated
      periodsUpdated
      periodsDeleted
      reporterDatesUpdated
      formUsersAdded
      reportersWithoutDates
    }
  }
  ${REPORTING_REQUIREMENT_DETAIL}
`;
